import yup from "./yup";

export const userSchemaRegister = yup.object().shape({
    userName:
        yup.string().label('Usuario')
            .required(),
    razonSocial:
        yup.string().label('Razón Social')
            .required(),
    cuit:
        yup.string().label('Numero de documento')
            .required(),
    address:
        yup.string()
            .label('Dirección y Número')
            .required(),
    city:
        yup.string()
            .label('Ciudad').required(),
    state:
        yup.string()
            .label('Provincia').required(),
    country:
        yup.string()
            .label('Pais').required(),
    phoneNumber:
        yup.string()
            .label('Teléfono').required(),
    email:
        yup.string().label('Email').email()
            .required(),
    zip:
        yup.string().label('Código Postal')
            .required(),
});